module.exports = __webpack_public_path__ + "img/curved1.06bfaf1f.jpg";